import { useState, useRef } from 'react';
import Hero from './components/Hero';
import WhyChoose from './components/WhyChoose';
import Benefits from './components/Benefits';
import GoogleReviews from './components/GoogleReviews';
import FAQ from './components/FAQ';
import UrgencyBanner from './components/UrgencyBanner';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import WhatsAppFloat, { WhatsAppFloatRef } from './components/WhatsAppFloat';

export default function Home() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const whatsappRef = useRef<WhatsAppFloatRef>(null);

  const handleScroll = () => {
    setShowScrollTop(window.scrollY > 500);
  };

  useState(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const openWhatsAppModal = () => {
    whatsappRef.current?.openModal();
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Fixed Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4 flex items-center justify-between">
          <img 
            src="/images/logo2.png" 
            alt="GIO Estética Avançada de Americana" 
            className="h-20 sm:h-24 w-auto"
          />
          <button 
            onClick={openWhatsAppModal}
            className="bg-[#E91E63] hover:bg-[#C2185B] text-white font-semibold text-base sm:text-lg px-5 sm:px-8 py-3 sm:py-4 rounded-full transition-all duration-300 hover:scale-105 shadow-lg shadow-[#E91E63]/30 whitespace-nowrap cursor-pointer"
          >
            Agendar Três Sessões Grátis
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="pt-14 sm:pt-16 md:pt-20">
        <Hero scrollToForm={openWhatsAppModal} />
        <WhyChoose />
        <Benefits />
        <GoogleReviews />
        <FAQ />
        <UrgencyBanner scrollToForm={openWhatsAppModal} />
        <FinalCTA scrollToForm={openWhatsAppModal} />
      </main>

      <Footer />

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-24 right-6 sm:bottom-28 sm:right-8 bg-[#E91E63] text-white w-12 h-12 sm:w-14 sm:h-14 rounded-full shadow-lg hover:bg-[#C2185B] transition-all duration-300 hover:scale-110 z-40 flex items-center justify-center cursor-pointer"
          aria-label="Voltar ao topo"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      )}

      {/* WhatsApp Float Button */}
      <WhatsAppFloat ref={whatsappRef} />
    </div>
  );
}
